import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";

interface IProfileEndorsementSection {
  showViewMore: boolean;
}

const ProfileEndorsementSection: React.FC<IProfileEndorsementSection> = ({
  showViewMore,
}) => {
  const endorsementsRef = useRef<HTMLDivElement | null>(null);
  const router = useRouter();

  useEffect(() => {
    if (router.query?.open === "endorsement" && endorsementsRef.current) {
      endorsementsRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div ref={endorsementsRef} className="flex justify-between items-center">
      <h2 className="text-xl font-bold text-white">Endorsements</h2>
      {showViewMore && (
        <div role="button">
          <Link
            href={{
              pathname: router.pathname,
              query: { myendorsements: "true" },
            }}
            shallow            
          >
            <span className="text-yellow">
              View More
            </span>            
          </Link>
        </div>
      )}
    </div>
  );
};

export default ProfileEndorsementSection;
